import { TPageLevelTraffic } from 'shared/atoms';
import { EPageType } from 'shared/constant/page-type';

export const PageTrafficUtil = {
  getPageIdFromTraffic: (traffic: TPageLevelTraffic): string => {
    switch (traffic.pageType) {
      case EPageType.Gallery:
      case EPageType.VIDEO:
        return traffic.groupId;
      case EPageType.HASHTAG:
        return traffic.hashtagId;
      case EPageType.POI:
        return traffic.poiId;
      case EPageType.USER:
      default:
        return traffic.userId;
    }
  },

  getEnterPageExtra: (traffic: TPageLevelTraffic): Record<string, string> => {
    switch (traffic.pageType) {
      case EPageType.Gallery:
        return {
          enter_page_type: EPageType.Gallery,
          enter_page_id: traffic.groupId,
        };
      case EPageType.VIDEO:
        return {
          enter_page_type: EPageType.VIDEO,
          enter_page_id: traffic.groupId,
        };
      case EPageType.HASHTAG:
        return {
          enter_page_type: EPageType.HASHTAG,
          enter_page_id: traffic.hashtagId,
        };
      case EPageType.POI:
        return {
          enter_page_type: EPageType.POI,
          enter_page_id: traffic.poiId,
        };
      case EPageType.USER:
      default:
        return {
          enter_page_type: EPageType.USER,
          enter_page_id: traffic.userId,
        };
    }
  },
};
